//@flow

import React from "react";
import type { ContextMenuConfigType, MenuItemType } from "@components";
import { ContextMenu, MenuItem } from "@components";
import { createPortal } from "react-dom";

export default function contextMenuTrigger(params: {
  column: Object,
  className?: string,
  isCellEditable: false,
  row: Object,
  rowIdx: number,
  tabIndex: number,
}) {
  const { column, row } = params;

  if (!column.contextMenuConfig(row)) return <></>;
  return (
    <ContextMenu
      align="left"
      clickTriggerEl={<span className="material-icons pointer">settings</span>}
    >
      {column.contextMenuConfig &&
        column.contextMenuConfig(row).map &&
        column.contextMenuConfig(row).map((item: MenuItemType) => {
          return (
            <MenuItem
              className={item.className || ""}
              key={item.label}
              icon={item.icon}
              label={item.label}
              onClick={item.onClick}
            />
          );
        })}
    </ContextMenu>
  );
}
